import styled from 'styled-components'

export const InputDescription = styled.div`
  font-size: 14px;
  margin-top: 50px;
  color: #D2DAEA;
  font-weight: 600;
`
